export default class PlayerStatus
{
	constructor()
	{
		this.values = new Array(8);
		this.values[0] = config.feed.floatOnLoadScrollDelay ? 'D' : config.feed.floatOnLoad ? 'L' : config.feed.float ? 'V' : 'N';
		this.values[2] = 'F';
		this.values[3] = config.feed.smartPlayer ? (config.playlist.type === 'SMART' ? 'P' : 'D') : config.feed.playerType === 'SINGLE' ? 'S' : 'N' ;
		this.values[5] = config.divTag.ownerDocument.location.href.includes('sendtonews.com/amp') ? 'A' : 'N';
		// todo: test and uncomment: this.values[5] = ((config.divTag.ownerDocument.location.hostname + config.divTag.ownerDocument.location.pathname).toLowerCase() === 'embed.sendtonews.com/amp/') ? 'A' : 'N';
		this.values[7] = config.feed.loopPlaylist ? 'Y' : 'N';
	}

	get logCode()
	{
		updateValues.call(this);
		return this.values.slice(0,6).join('');
	}

	get dfpCode()
	{
		updateValues.call(this);
		return this.values.join('');
	}

	next()
	{
		this.values[2] = 'N';
	}
}

function updateValues()
{
	const ac_id = config.ac_id;
	const width = config.player.layoutGrid.mediaGroupContainer.element.clientWidth;

	this.values[1] = ac_id.userLoaded ? 'U' : ac_id.pov ? 'V' : ac_id.autoplay ? 'A' : 'C';
	this.values[4] = width < 400 ? 'S' : width > 600 ? 'L' : 'M';
	this.values[6] = ac_id.getViewabilityValue();
}